"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeNamespaceDeclarations = exports.applyAttributesNsGroups = exports.applyAttributesNs = exports.applyAttributes = void 0;

var _ramda = require("ramda");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var applyAttributes = function applyAttributes(element, attributes) {
  for (var _i = 0, _Object$entries = Object.entries(attributes || {}); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    element.setAttribute(name, value);
  }
}; // (DOMElement, { String: String }, String) -> void


exports.applyAttributes = applyAttributes;

var applyAttributesNs = function applyAttributesNs(element, nsAttributes, namespaceURI) {
  if (!namespaceURI) {
    applyAttributes(element, nsAttributes);
    return;
  }

  for (var _i2 = 0, _Object$entries2 = Object.entries(nsAttributes || {}); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        name = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];

    element.setAttributeNS(namespaceURI, name, value);
  }
}; // (DOMElement, { String: { String: String } }) -> void


exports.applyAttributesNs = applyAttributesNs;

var applyAttributesNsGroups = function applyAttributesNsGroups(el, nsAttributesMap) {
  for (var _i3 = 0, _Object$entries3 = Object.entries(nsAttributesMap || {}); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
        namespace = _Object$entries3$_i[0],
        attr = _Object$entries3$_i[1];

    applyAttributesNs(el, attr, namespace);
  }
}; // NamespaceMap -> { String: String }


exports.applyAttributesNsGroups = applyAttributesNsGroups;
var makeNamespaceDeclarations = (0, _ramda.compose)(_ramda.fromPairs, (0, _ramda.map)(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      prefix = _ref2[0],
      uri = _ref2[1];

  return ["xmlns:".concat(prefix), uri];
}), _ramda.toPairs, (0, _ramda.filter)(Boolean));
exports.makeNamespaceDeclarations = makeNamespaceDeclarations;